import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppRoute } from 'appRoutes'
import { CustomSubdomainListPage } from 'features/customSubdomains'
import { QUERY_KEY as contextQueryKey } from 'hooks/api/context'
import { certificatesQueryKey } from 'hooks/api/ssl_certificates'
import { subscriptionQueryKey } from 'hooks/api/subscriptions'
import { canEditConfigurationPermission, canViewConfigurationPermission, permissionQueryKey } from 'hooks/usePermission'
import { Limits, SSLCertificate, Subscription, SubscriptionStatus, UserContext, WorkspacePermission } from 'models'

import { subdomainSchema } from './-subdomainsSchema'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/subdomains/')({
  component: CustomSubdomainListPage,
  validateSearch: subdomainSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Subdomains'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewConfigurationPermission)(ctx)

    if (ctx.cause === 'preload') {
      return
    }

    const { queryClient } = ctx.context
    const { subscriptionId } = ctx.params
    const certificates = queryClient.getQueryData<SSLCertificate[]>(certificatesQueryKey(subscriptionId))
    const userContext = queryClient.getQueryData<UserContext>(contextQueryKey)
    const subscription = queryClient.getQueryData<Subscription>(subscriptionQueryKey(subscriptionId))
    const permissions = queryClient.getQueryData<{ data: WorkspacePermission[] }>(permissionQueryKey(subscriptionId))

    const certificatesLimit = userContext?.limits.find(
      (limit) => limit.entityId === subscriptionId && limit.id === Limits.SslCertificates
    )?.value

    if (
      certificates === undefined ||
      userContext === undefined ||
      subscription === undefined ||
      permissions === undefined ||
      certificatesLimit === undefined
    ) {
      return
    }

    if (
      certificates.length === 0 &&
      certificatesLimit > 0 &&
      subscription.status !== SubscriptionStatus.Canceled &&
      permissions.data.includes(canEditConfigurationPermission)
    ) {
      throw redirect({
        to: AppRoute.Subdomain,
        params: { subscriptionId, certificateId: 'new' },
        replace: true,
      })
    }
  },
})
